<template>
	<div class="wrapper-cell">
		<el-date-picker 
			v-model="row[column.key]" 
			type="date" 
			value-format="yyyy-MM-dd" 
			placeholder="选择日期"
			@change="validateDate"
		></el-date-picker>
        <!-- :picker-options="pickerOptions" -->
        <span v-if="column.required" class="required-star">*</span>
		<div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';

export default {
	name: 'promotionEndTimeInputCell',
	mixins: [mixin],
	data() {
		return {
			errorMsg: '',
			// pickerOptions: {
			// 	disabledDate: (time) => {
			// 		//今天之前的日期
			// 		return time.getTime() < Date.now() - 8.64e7;
			// 	}
			// }
		};
	},
	methods: {
		validateDate(value) {
			if (!value) {
				this.errorMsg = '推广结束时间不可为空';
				return;
			}
			this.errorMsg = '';
		}
	}
};
</script>

<style scoped>
.wrapper-cell{
    position: relative;
    padding-bottom: 20px;
}
.required-star {
	color: #f56c6c;
    position: absolute;
    left: -12px;
    top: 6px;
}
.error-msg {
	color: #f56c6c;
	font-size: 12px;
    position: absolute;
    left: 2px;
    bottom: 0px;
}
</style>